import React from "react";
import PropTypes from "prop-types";
import { Stack, Button } from "react-bootstrap";
import * as AiIcons from "react-icons/ai";
import TableAgentRCS from "./TableAgentRCS";
import { useQuery } from "@tanstack/react-query";
import { httpClient } from "../../../../utils/HttpClient";
import { ApiEndpoint } from "../../../../utils/ApiEndpoint";
import { useAuth } from "../../../../Context/AuthContext";
import _ModalCreateRCSAgent from "../../../modal/administration/customer/_ModalCreateRCSAgent";
const CustomerAgentRCS = (props) => {
  const { uidCustomer, idCustomer } = props;
  const auth = useAuth();
  const { token } = auth.getSessionData();
  const [visible, setVisible] = React.useState(false);
  const {
    data: agentsRcs,
    isFetching: isLoading,
    refetch: refetchAgentsRcs,
  } = useQuery({
    queryKey: ["agentsRcs", idCustomer],
    queryFn: async () => {
      const response = await httpClient(
        "get",
        `${ApiEndpoint}administration/rcsagentsbycustomer/${uidCustomer}`,
        {},
        token,
      );
      return response.data;
    },
    initialData: [],
    refetchOnWindowFocus: false,
  });

  return (
    <div>
      <Stack direction="horizontal" gap={2} className="wrappTitle">
        <h4>Lista de Agentes RCS</h4>
        <div className="ms-auto">
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={() => {
              setVisible(true);
            }}
          >
            <AiIcons.AiOutlinePlus /> Agregar
          </Button>{" "}
        </div>
      </Stack>
      <TableAgentRCS
        data={agentsRcs}
        isLoading={isLoading}
        refetchAgentsRcs={refetchAgentsRcs}
      />
      <_ModalCreateRCSAgent
        title="Agregar Agente RCS"
        visible={visible}
        onClose={() => setVisible(!visible)}
        data={{
          idCustomer: idCustomer,
          uidCustomer: uidCustomer,
        }}
        refetchAgentsRcs={refetchAgentsRcs}
      />
    </div>
  );
};

CustomerAgentRCS.propTypes = {
  idCustomer: PropTypes.number,
  partnersData: PropTypes.array,
  uidCustomer: PropTypes.string,
};
export default CustomerAgentRCS;
